export const ACTIONS_EXPRESS_SETTING_REDUCER = {
  CALLING_API: "call-update-api",
  CALL_API_SUCCESS: "call-update-api-success",
  CALL_API_ERROR: "call-update-api-error",
  INITIAL_DATA: "initial-data", // update by initial all form data
  UPDATE_DATA: 'update-data' // update field by field when onchange
}

export const formExpressSettingReducer = (formExpressSettingState, action) => {
  switch (action.type){
    case ACTIONS_EXPRESS_SETTING_REDUCER.CALLING_API: {
      return {...formExpressSettingState, isSubmittingExpressSetting: true};
    }
    case ACTIONS_EXPRESS_SETTING_REDUCER.CALL_API_SUCCESS: {
      return {isSubmittingExpressSetting: false, formExpressSettingState: action.data}
    }
    case ACTIONS_EXPRESS_SETTING_REDUCER.CALL_API_ERROR: {
      return {...formExpressSettingState, isSubmittingExpressSetting: false,submitExpressSettingError: action.error }
    }
    case ACTIONS_EXPRESS_SETTING_REDUCER.INITIAL_DATA: {
      return {isSubmittingExpressSetting: false, formExpressSettingState: action.data}
    }
    case ACTIONS_EXPRESS_SETTING_REDUCER.UPDATE_DATA: {
      const {name, value} = action.data;
      return {submitExpressSettingError: null, isSubmittingExpressSetting:false, ...formExpressSettingState,[name]: value}
    }
    default:
      return formExpressSettingState;
  }
}